import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { BOLD, FILL_30PARENT, FILL_PARENT, FLEX, POINTER, SB } from "../../../constant/typograpy/properties";
import px from "../../../constant/scripts/px";
import { BLACK, SKYBLUE } from "../../../constant/typograpy/colors";
import UserManager from "../AdvanceComp/UserManger";
import { converIntoFormData, convertUTCToIST } from "../../../constant/scripts/helper";

export default function AdminActionPanel({ id, actions, el, keyy, element = <i className="fa fa-pencil" style={{ width: 35, fontSize: 16, padding: 11, color: 'rgb(40, 167, 69)' }}></i> }) {
    const [modal, setModal] = useState(false)
    const [role, setRole] = useState(el.role)
    const [active, setActive] = useState(el.isActive)
    const toggle = () => setModal(!modal)
    // const [allocatedUsers, setAllocatedUsers] = useState([el.userId])
    // const [dropdownOpen, setDropdownOpen] = useState(false);
    // const toggle = () => setDropdownOpen(prevState => !prevState);

    // console.log(el)
    return <>
        <div key={keyy}>
            {/* <span style={{ cursor: POINTER }}><i className="fa fa-trash" style={{ width: 35, fontSize: 16, padding: 11, color: '#e4566e' }}></i></span> */}
            <span>
                <span style={{ cursor: POINTER }} onClick={toggle}>{element}</span>
                <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle}>{"Edit Admin"}</ModalHeader>
                    <ModalBody>
                        <div className="card">
                            <div className="card-header">
                                <h5>{el.props.name}</h5><span>Modify admin properties here and click on save to make changes.</span>
                            </div>
                            <div className="card-body">

                                <form className="theme-form" style={{ flex: 2 }}>

                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label" htmlFor="createdAt">{"Created At"}</label>
                                        <div className="col-sm-9">
                                            <p className="form-control">{convertUTCToIST(el.created_at)}</p>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label" htmlFor="role">{"Role"}</label>
                                        <div className="col-sm-9">
                                            <select className="form-control" value={role} onChange={(e) => setRole(e.target.value)}>
                                                <option value="admin">Admin</option>
                                                <option value="superadmin">Super Admin</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label" htmlFor="active">{"Active"}</label>
                                        <div className="col-sm-9">
                                            <select className="form-control" value={active} onChange={(e) => setActive(e.target.value)}>
                                                <option value={true}>Active</option>
                                                <option value={false}>Disable</option>
                                            </select>
                                        </div>
                                    </div>

                                    {/* <div className="form-group row">
                                        <label className="col-sm-3 col-form-label" htmlFor="manage">{"Manage Users"}</label>
                                        <div className="col-sm-9">
                                            <div className="form-control" style={{ padding: "16px" }}>
                                                <UserManager allocatedUsers={allocatedUsers} setAllocatedUsers={setAllocatedUsers} filterList={[{ name: "ID", value: "id" }, { name: "Email", value: "email" }, { name: "Name", value: "displayName" }]} />
                                            </div>
                                        </div>
                                    </div> */}

                                </form>
                            </div>

                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => {
                            actions.handlePatch(converIntoFormData({
                                userId: el.userId,
                                isActive: active
                            }))
                        }}>{"Save"}</Button>
                        <Button color="secondary" onClick={toggle}>{"Cancel"}</Button>
                    </ModalFooter>
                </Modal>
            </span>
        </div>
    </>
}